module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/coupons/discount-type/discount-type-list/discount-type-list.component.scss
// module id = ./src/app/coupons/discount-type/discount-type-list/discount-type-list.component.scss
// module chunks = main